// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/dietz-jubilarfeier/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const dietzJubilarfeierDE: PageEntry = {
  id: "post.dietz-jubilarfeier",
  locale: "de",
  slug: "dietz-jubilarfeier",
  seo: {
    title: "Dietz Jubilarfeier | Dietz GmbH",
    description: "Dietz Jubilarfeier",
  },
  type: "post",
  h1: "Dietz Jubilarfeier",
  blocks: [
    { kind: "heading", level: 2, text: "Dietz Jubilarfeier" },
    { kind: "paragraph", text: "Vergangenen Freitag (12.11.2021) konnten wir insgesamt 18 Jubilare für die langjährige Tätigkeit in und für unsere Firma ehren." },
    { kind: "paragraph", text: "Gemeinsam sind wir in dieser Zeit vorangekommen und konnten einiges erreichen." },
    { kind: "paragraph", text: "Alle Jubilare haben in diesem Jahr einen eigenen Baum im Familienwald der Stadt Neustadt erhalten." },
    { kind: "paragraph", text: "Wir freuen uns auf eine weiterhin gute Zusammenarbeit." }
  ],
};
